export default __webpack_public_path__ + "static/favicon-15a65554ecb2c713b01977f56fa6e078.ico";